// test393
(393 && 0);
